import axiosBaseApi from '@/services/common/lib/axiosBaseApi';

export const postTableInit = (tableId: string) => {
  return axiosBaseApi.post(`/v1/poker-table/${tableId}/init`);
};
